import { SQLString } from "../types";

/**
 * SQL tagged template literal for better syntax highlighting and formatting
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sql = (strings: TemplateStringsArray, ...values: any[]): SQLString => {
  return strings
    .reduce((query, string, i) => query + string + (values[i] || ""), "")
    .trim() as SQLString;
};
